import React, { useState } from 'react';
import { AppLayout } from '@amzn/awsui-components-react-v3';
import '../../styles/global.css';
import '../../styles/spotcp.css';
import Navigation from './navigation';
import SpotcpContent from './contents';
import { SpotcpInfo } from './info';
import { SpotcpContextProvider } from './context/spotcp-context';

export default (props) => {
  const [toolsContent, setToolsContent] = useState(<SpotcpInfo />);
  const [toolsOpen, setToolsOpen] = useState(false);
  return (
    <SpotcpContextProvider>
      <AppLayout
        className="awsui-util-no-gutters"
        content={
          <SpotcpContent
            updateTools={(toolsContent) => {
              setToolsContent(toolsContent);
              setToolsOpen(true);
            }}
          />
        }
        navigation={<Navigation/>}
        tools={toolsContent}
        toolsOpen={toolsOpen}
        onToolsChange={({ detail }) => setToolsOpen(detail.open)}
      />
      <div id="spotcp-footer">
        <div id="console-nav-footer" className="Footer">
          Highly Confidential Data
        </div>
      </div>
    </SpotcpContextProvider>
  );
};


// WEBPACK FOOTER //
// ./src/components/spotcp/accuracy.jsx